export const getSectionsToRenderByUpdate = () => {
  const cartShippingEl = document.getElementById('cart-shipping');
  return [
    {
      id: 'cart-header',
      section: 'cart-header',
      selector: '.Cart__item-count',
    },
    {
      id: 'cart-indicator',
      section: 'cart-indicator',
      selector: '.shopify-section',
      reused: true,
    },
    ...(cartShippingEl
      ? [{ id: 'cart-shipping', section: cartShippingEl.dataset.id, selector: '[data-cart-total-container]' }]
      : []),
    {
      id: 'cart-totals',
      section: 'cart-totals',
      selector: '.CartTotals__container',
    },
    {
      id: 'cart-items',
      section: document.getElementById('cart-items').dataset.id,
      selector: '[data-cart]',
    },
  ];
};

export const getSectionsToRenderByAdd = () => {
  const cartShippingEl = document.getElementById('cart-shipping');
  return [
    {
      id: 'cart-header',
      section: 'cart-header',
      selector: '.Cart__item-count',
    },
    {
      id: 'cart-indicator',
      section: 'cart-indicator',
      selector: '.shopify-section',
      reused: true,
    },
    ...(cartShippingEl
      ? [{ id: 'cart-shipping', section: cartShippingEl.dataset.id, selector: '[data-cart-total-container]' }]
      : []),
    {
      id: 'cart-totals',
      section: 'cart-totals',
      selector: '.CartTotals__container',
    },
    {
      id: 'cart-items',
      section: document.getElementById('cart-items').dataset.id,
      selector: '[data-cart]',
    },
  ];
};

export const getSectionsToRenderByPDP = (cartItemKey = '') => [
  {
    id: 'cart-indicator',
    section: 'cart-indicator',
    selector: '.shopify-section',
    reused: true, // This is a reused section across the site
  },
  {
    id: 'cart-atb-content',
    section: 'cart-atb',
    selector: `[id="cart-atb-product-${cartItemKey}"]`,
  },
  {
    id: 'cart-atb-cta-buttons',
    section: 'cart-atb-cta-buttons',
    selector: '.shopify-section',
  },
];
